// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file bffuser/v1/workflow_auto_creation_rule_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import { WorkflowAutoCreationRuleService } from "./workflow_auto_creation_rule_service_pb";

/**
 * ListWorkflowAutoCreationRules returns the active rules of the
 * organization, ordered by created_at then id. Rules whose template is
 * deleted or cannot be resolved are not returned.
 *
 * @generated from rpc bffuser.v1.WorkflowAutoCreationRuleService.ListWorkflowAutoCreationRules
 */
export const listWorkflowAutoCreationRules = WorkflowAutoCreationRuleService.method.listWorkflowAutoCreationRules;

/**
 * CreateWorkflowAutoCreationRules creates one rule per requested area,
 * skipping areas that already have a scheduled rule (enabled or not) with
 * the same template and the same schedule.lead_*. The lead is accepted only
 * as 0 to 30 days (INVALID_ARGUMENT otherwise, including month / year
 * units). Returns ALREADY_EXISTS when every requested area is skipped, and
 * FAILED_PRECONDITION when the template does not exist in the organization
 * or cannot have a scheduled rule.
 *
 * @generated from rpc bffuser.v1.WorkflowAutoCreationRuleService.CreateWorkflowAutoCreationRules
 */
export const createWorkflowAutoCreationRules = WorkflowAutoCreationRuleService.method.createWorkflowAutoCreationRules;

/**
 * UpdateWorkflowAutoCreationRule changes enabled, fire_time and day_filter
 * of a rule; the id never changes. workflow_template_id, area_code and
 * schedule.lead_* identify the rule and must equal its current values,
 * otherwise INVALID_ARGUMENT and nothing is saved. FAILED_PRECONDITION (flag
 * off) and INVALID_ARGUMENT (malformed input) are returned regardless of the
 * rule's state; after that the order is NOT_FOUND for a missing rule,
 * INVALID_ARGUMENT for a changed template / area / lead, FAILED_PRECONDITION
 * when the rule's current template is no longer eligible, and ABORTED when
 * expected_updated_at does not match.
 *
 * @generated from rpc bffuser.v1.WorkflowAutoCreationRuleService.UpdateWorkflowAutoCreationRule
 */
export const updateWorkflowAutoCreationRule = WorkflowAutoCreationRuleService.method.updateWorkflowAutoCreationRule;

/**
 * DeleteWorkflowAutoCreationRule logically deletes a rule. Returns NOT_FOUND
 * for a missing rule and ABORTED when expected_updated_at does not match.
 *
 * @generated from rpc bffuser.v1.WorkflowAutoCreationRuleService.DeleteWorkflowAutoCreationRule
 */
export const deleteWorkflowAutoCreationRule = WorkflowAutoCreationRuleService.method.deleteWorkflowAutoCreationRule;
